angular.module('bzLocationModule').factory('userLocationModel', [
  'userLocationData',
  function (userLocationData) {
    return {
      data: userLocationData,
    }
  },
])
